import { Tooltip, Typography, useTheme } from "@mui/material";

import { InfoIcon } from "@phosphor-icons/react/dist/csr/Info";

const RoleDisclaimer = ({ roleLabel }: { roleLabel: string }) => {
  const theme = useTheme();

  return (
    <Typography
      variant="body.medium.regular"
      sx={{
        color: "text40.main",
        marginLeft: "8px",
        display: "flex",
        alignItems: "center",
      }}
    >
      (derived from global role
      <Tooltip
        title={`This option overrides the ${roleLabel} global role and stays remains even if the ${roleLabel} global role is deactivated.`}
        arrow
        placement="right"
        slotProps={{
          tooltip: {
            sx: { maxWidth: "280px" },
          },
        }}
      >
        <span style={{ display: "inline-flex", marginLeft: "2px", marginRight: "2px" }}>
          <InfoIcon size={20} color={theme.palette.text40.main} />
        </span>
      </Tooltip>
      )
    </Typography>
  );
};

export { RoleDisclaimer };
